import AddUserGroupModal from './add-user-group-modal.vue'
export default AddUserGroupModal
